// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__8fnRy","checkedWrapper":"styles_checkedWrapper__IviOP","checkedIndicator":"styles_checkedIndicator__p08+x"};